import { useEffect } from 'react'
import { dismissStaticShellSplash } from './dismissStaticShellSplash'

export function useDismissStaticShellSplash(): void {
  useEffect(() => {
    dismissStaticShellSplash()
  }, [])
}
